import { forwardRef } from 'react'
import { AreaInfo } from '@/components/pages/AreaPageModern/components/AreaPageMain/components/AreaPageFindCar/components/AreaInfo/AreaInfo'
import { AreaInfoResponseData } from '@/store/slices/stagesSlice/interfaces'
import { FindCarLabel } from '@/components/pages/AreaPageModern/components/AreaPageMain/components/AreaPageFindCar/components/FindCarLabel/FindCarLabel'
import { FindCarInput } from '@/components/pages/AreaPageModern/components/AreaPageMain/components/AreaPageFindCar/components/FindCarInput/FindCarInput'
import styles from './AreaPageFindCar.module.scss'

type AreaPageFindCarProps = {
  area: AreaInfoResponseData | null
  carNumber: string
  setCarNumber: (value: string) => void
  error?: string
}

export const AreaPageFindCar = forwardRef<HTMLInputElement, AreaPageFindCarProps>(
  ({ area, carNumber, setCarNumber, error }, ref) => {
    const isOnlyCarNumber = area?.ticket_type === 'only_car'

    return (
      <div>
        <div className={styles.info}>
          <AreaInfo address={area?.address} name={area?.name} />
          <FindCarLabel isOnlyCarNumber={isOnlyCarNumber} />
        </div>
        <FindCarInput
          ref={ref}
          value={carNumber}
          error={error}
          onChange={setCarNumber}
          isOnlyCarNumber={isOnlyCarNumber}
        />
      </div>
    )
  },
)
